import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'website-wrike-logo',
    standalone: true,
    templateUrl: './wrike-logo.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'header-logo__image' },
})
export class WrikeLogoComponent {
    @Input() isDarkTheme = false;
}
